import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultPhraseInfo } from '../interfaces/PhraseIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C303PhraseDeleteProps {
  execPhraseDelete: (deviceId: string, phrase_text: string) => Promise<ResultPhraseInfo>
  loading: loadStatus
}
// C303 優先単語削除API呼出
export const useC303PhraseDelete = (): C303PhraseDeleteProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execPhraseDelete = async (deviceId: string, text: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.delete(
        `${buildDeviceUrl(deviceId, apiUrl.phrasesPath)}`,
        {
          headers: header,
          data: {
            text,
            language: 'jp',
          },
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execPhraseDelete, loading }
}
